export * from './cloud-product-detail-view';
